/**
 * Recently Viewed Products
 *
 * How it works:
 *   1. On every product page: saves the current product handle to localStorage.
 *   2. Reads the list of previously viewed handles (excluding the current page).
 *   3. For each handle, fetches a rendered product card via Shopify's Section
 *      Rendering API (/products/{handle}?sections=recently-viewed-item).
 *   4. Appends the cards to the grid and reveals the container.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lm_recently_viewed';
  var MAX_STORED  = 20;

  /* ── localStorage helpers ─────────────────────────────────── */

  function getViewed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveHandle(handle) {
    var viewed = getViewed().filter(function (h) { return h !== handle; });
    viewed.unshift(handle);
    if (viewed.length > MAX_STORED) viewed = viewed.slice(0, MAX_STORED);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
    } catch (e) {}
  }

  /* ── Render ───────────────────────────────────────────────── */

  function renderRecentlyViewed() {
    var container = document.querySelector('.recently-viewed[data-current]');
    if (!container) return;

    var current = container.dataset.current;
    var max     = parseInt(container.dataset.max, 10) || 4;
    var grid    = container.querySelector('[id^="recently-viewed-grid"]');
    if (!grid) return;

    var handles = getViewed()
      .filter(function (h) { return h !== current; })
      .slice(0, max);

    if (handles.length === 0) return;

    /* Fetch all product cards in parallel, preserving order */
    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '?sections=recently-viewed-item')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      var count = 0;

      results.forEach(function (data) {
        if (!data || !data['recently-viewed-item']) return;

        /* Section Rendering API wraps the output — extract the <li> */
        var tmp = document.createElement('ul');
        tmp.innerHTML = data['recently-viewed-item'];
        var li = tmp.querySelector('li');
        if (li) {
          grid.appendChild(li);
          count++;
        }
      });

      /* Only reveal the section if at least one card loaded */
      if (count > 0) {
        container.style.display = '';
      }
    });
  }

  /* ── Init ─────────────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.recently-viewed[data-current]');
    if (!container) return;

    /* Save this page first, then render the others */
    saveHandle(container.dataset.current);
    renderRecentlyViewed();
  });
})();
